var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/close-small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.7489487,6.25105133 C18.0579349,6.56003758 18.0817031,7.04623563 17.8202532,7.38248524 L17.7489487,7.46323438 L13.212,12 L17.7489487,16.5367656 C18.0836838,16.8715007 18.0836838,17.4142136 17.7489487,17.7489487 C17.4399624,18.0579349 16.9537644,18.0817031 16.6175148,17.8202532 L16.5367656,17.7489487 L12,13.212 L7.46323438,17.7489487 C7.12849928,18.0836838 6.58578644,18.0836838 6.25105133,17.7489487 C5.94206508,17.4399624 5.9182969,16.9537644 6.17974681,16.6175148 L6.25105133,16.5367656 L10.788,12 L6.25105133,7.46323438 C5.91631622,7.12849928 5.91631622,6.58578644 6.25105133,6.25105133 C6.56003758,5.94206508 7.04623563,5.9182969 7.38248524,6.17974681 L7.46323438,6.25105133 L12,10.788 L16.5367656,6.25105133 C16.8715007,5.91631622 17.4142136,5.91631622 17.7489487,6.25105133 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/close-small",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmall);
export default __webpack_public_path__ + "static/media/close-small.efd868f550dfb9aeab49d3e2c125e9cd.svg";
export { ForwardRef as ReactComponent };